import React from 'react'
import { Redirect } from 'react-router'

import ViewsLoader from '../components/loader/ViewsLoader'

import FirebaseApp from '../services/firebaseApp'

import { selectProfileData } from '../store/user/userSlice'
import { selectedEvent } from '../store/events/eventsSlice'
import { useAppSelector } from '../store/hooks'

import { IUserMode, USE_MODE_CONST } from '../const/use-mode'
import { CONST } from '../const/const'

type IProps = {
  children: React.ReactElement | null
  scope: IUserMode[]
  onlyOrganizerOwner?: boolean
}

const ProtectedRoute = (props: IProps) => {
  const currentUser = FirebaseApp.auth.currentUser

  let unauthorize = false
  let redirectPath: string | null = null

  let profileData = useAppSelector(selectProfileData)
  const { Event } = useAppSelector(selectedEvent)

  if (currentUser && !profileData.userType)
    return (
      <ViewsLoader
        isPageLoader={true}
        className="flex items-center w-full justify-center h-screen"
        size="xl"
        color="red"
      />
    )

  if (!props.scope.includes((profileData?.userType as IUserMode) || null)) {
    unauthorize = true
  } else if (
    props.onlyOrganizerOwner &&
    Event?.owner &&
    profileData?.id &&
    Event.owner !== profileData.id
  ) {
    unauthorize = true
  }

  if (unauthorize) {
    switch (profileData.userType) {
      case USE_MODE_CONST.STAFF:
        redirectPath = CONST.ROUTES.HOME.URL
        break
      case USE_MODE_CONST.COMPETITOR:
        redirectPath = CONST.ROUTES.HOME.URL
        break
      case USE_MODE_CONST.ORGANIZER:
        redirectPath = CONST.ROUTES.ORGANIZER_HOME.URL
        break
      default:
        redirectPath = CONST.ROUTES.SEARCH.URL
    }
  }

  if (unauthorize && redirectPath) return <Redirect to={redirectPath} />

  return props.children
}

export default ProtectedRoute
